import { apiSlice } from './apiSlice';

export interface TransitAspectRow {
  natalSign: string;
  natalPlanets: string;
  houseFromRashiMoon: number;
  transitingPlanets: string;
  aspects: string; 
  signsAspected: string;
  housesAspectedFromRashiMoon: string;
  planetsAspected: string;
  sign: string;
}

export interface TransitAspectResponse {
  date?: string;
  transitAspect?: TransitAspectRow[];
}

export const planetaryTransitAspectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetaryTransitAspect: builder.query<
      TransitAspectResponse,
      { userId: string; rashi: string }
    >({
      query: ({ userId, rashi }) => ({
        url: '/astrology/transite-aspect',
        method: 'GET',
        params: {
          userId,
          rashi,
        },
      }),
    }),
  }),
});

export const { useGetPlanetaryTransitAspectQuery } = planetaryTransitAspectApi;
